import { render, staticRenderFns } from "./VaccinationActionList.vue?vue&type=template&id=24d48e16&scoped=true&"
import script from "./VaccinationActionList.vue?vue&type=script&lang=js&"
export * from "./VaccinationActionList.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationActionList.vue?vue&type=style&index=0&id=24d48e16&lang=scss&scoped=true&"
import style1 from "./VaccinationActionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d48e16",
  null
  
)

export default component.exports